import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import {
  GetSingleProdi,
  CreateProdi,
  EditProdi,
  reset,
} from "../../../features/ProdiSlice";

import Swal from "sweetalert2";
import Select from "react-select";
import { Card, Button, Form, Col, Row } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleLeft,
  faPencilAlt,
} from "@fortawesome/free-solid-svg-icons";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";
import api from "../../../api";

const FormProdiPage = () => {
  const [dataFakultas, setDataFakultas] = useState([]);
  const [newData, setNewData] = useState({
    kode: "",
    nama: "",
    id_fakultas: "",
  });

  const dispatch = useDispatch();
  const { data, isEdit, isCreate } = useSelector((state) => state.prodi);

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    const source = axios.CancelToken.source();
    const fetchData = async () => {
      try {
        // Ambil data fakultas
        const fakultasResponse = await axios.get(`${api}/master/fakultas`, {
          cancelToken: source.token,
        });

        const fakultasFormated = fakultasResponse.data.data.map((fakultas) => ({
          value: fakultas.id,
          label: fakultas.nama,
        }));
        setDataFakultas(fakultasFormated);
      } catch (error) {
        console.log(error);
      }
    };

    if (id) {
      dispatch(GetSingleProdi({ id, token }));
    }

    if (isEdit || isCreate) {
      Swal.fire({
        title: "Berhasil",
        showConfirmButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          navigate("/master/prodi/list");
        }
      });
    }

    fetchData();

    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, [id, dispatch, token, isEdit, isCreate, navigate]);

  useEffect(() => {
    setNewData({
      nama: data?.data?.nama,
      kode: data?.data?.kode,
      id_fakultas: data?.data?.id_fakultas,
    });
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (id) {
      dispatch(
        EditProdi({
          id,
          nama: newData.nama,
          kode: newData.kode,
          id_fakultas: newData.id_fakultas,
          token,
        })
      );
    } else {
      dispatch(reset());
      dispatch(
        CreateProdi({
          nama: newData.nama,
          kode: newData.kode,
          id_fakultas: newData.id_fakultas,
          token,
        })
      );
    }
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[3] === "view" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/${param.pathname.split("/")[1]}/edit/${id}`}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="me-2" />
              Edit
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "add" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/${param.pathname.split("/")[1]}/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "edit" ? (
        <>
          <Header>
            <Button
              variant="outline-primary"
              size="sm"
              href={`/${param.pathname.split("/")[1]}/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}

      <Card border="light" className="shadow-sm mb-4">
        {param.pathname.split("/")[3] === "view" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
            isLocked={true}
            dataFakultas={dataFakultas}
          />
        ) : param.pathname.split("/")[3] === "add" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
            dataFakultas={dataFakultas}
          />
        ) : param.pathname.split("/")[3] === "edit" ? (
          <FormPage
            newData={newData}
            setNewData={setNewData}
            handleSubmit={handleSubmit}
            dataFakultas={dataFakultas}
          />
        ) : null}
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  newData,
  setNewData,
  id,
  isLocked = false,
  handleSubmit,
  dataFakultas,
}) => {
  const param = useLocation();

  return (
    <Card.Body>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12} className="mb-3">
            <Form.Group id="kode">
              <Form.Label>Kode</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Kode"
                name="kode"
                disabled={isLocked}
                value={newData.kode || ""}
                onChange={(e) =>
                  setNewData({ ...newData, kode: e.target.value })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="Nama">
              <Form.Label>Nama</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nama"
                name="nama"
                disabled={isLocked}
                value={newData.nama || ""}
                onChange={(e) =>
                  setNewData({ ...newData, nama: e.target.value })
                }
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-3">
            <Form.Group id="id_fakultas">
              <Form.Label>Fakultas</Form.Label>

              {param.pathname.split("/")[3] === "view" ? (
                <Select
                  isDisabled
                  options={dataFakultas}
                  value={dataFakultas.find(
                    (item) => item.value === newData.id_fakultas
                  )}
                  placeholder="Pilih fakultas"
                  autoFocus
                  onChange={(e) => {
                    setNewData({
                      ...newData,
                      id_fakultas: e.value,
                    });
                  }}
                />
              ) : id ? (
                <Select
                  options={dataFakultas}
                  placeholder="Pilih fakultas"
                  autoFocus
                  isDisabled
                  onChange={(e) => {
                    setNewData({
                      ...newData,
                      id_fakultas: e.value,
                    });
                  }}
                />
              ) : (
                <Select
                  value={dataFakultas.find(
                    (item) => item.value === newData.id_fakultas
                  )}
                  options={dataFakultas}
                  placeholder="Pilih fakultas"
                  autoFocus
                  onChange={(e) => {
                    setNewData({
                      ...newData,
                      id_fakultas: e.value,
                    });
                  }}
                />
              )}
            </Form.Group>
          </Col>
        </Row>
        <div>
          {!isLocked ? (
            <Button type="submit">{id ? "Update" : "Simpan"}</Button>
          ) : null}
        </div>
      </Form>
    </Card.Body>
  );
};

export default FormProdiPage;
